// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
export var EReportRequestParameter;
(function (EReportRequestParameter) {
    EReportRequestParameter["FromDate"] = "fromDate";
    EReportRequestParameter["ToDate"] = "toDate";
    EReportRequestParameter["Begin"] = "begin";
    EReportRequestParameter["End"] = "end";
    EReportRequestParameter["Login"] = "login";
    EReportRequestParameter["UserId"] = "userid";
    EReportRequestParameter["Instruments"] = "instruments";
    EReportRequestParameter["InstrumentID"] = "InstrumentId";
    EReportRequestParameter["AccountID"] = "AccountId";
    EReportRequestParameter["OrderId"] = "OrderId";
    EReportRequestParameter["PositionId"] = "PositionId";
    EReportRequestParameter["ShowLots"] = "IsShowLots";
    EReportRequestParameter["ReportType"] = "reporttype";
    EReportRequestParameter["Asset"] = "asset";
    EReportRequestParameter["Types"] = "Types";
    EReportRequestParameter["UseLanguageAliases"] = "useLanguageAliases";
    EReportRequestParameter["FromRecordId"] = "fromRecordId";
    EReportRequestParameter["RecordsNumber"] = "recordsNumber";
})(EReportRequestParameter || (EReportRequestParameter = {}));
export class ReportRequestConfig {
    constructor(reportType, isTechnical = true) {
        this.isTechnical = true;
        this.params = new Map();
        this.reportType = reportType;
        this.isTechnical = isTechnical;
    }
    getParameter(key) {
        var _a;
        return (_a = this.params.get(key)) !== null && _a !== void 0 ? _a : null;
    }
    addParameter(key, value) {
        if (!isNullOrUndefined(value)) {
            this.params.set(key, value);
        }
    }
}
